<template>
  <std-form-page
      ref="page"

      :id="login"
      :item="item"
      identity="login"

      url="/users"
      resource="user"

      icon="bi-person-lines-fill"
      title-new="Создать новую учетную запись"
      :title="'Пользователь ' + item?.name || login"

      :before-send="beforeSend"

      :no-delete="true"
      :no-edit="noEdit"
  >

    <template v-slot:default="form">
      <f-input v-model="item.login" label="Логин" w="12" :disabled="!!this.login"/>
      <f-input v-model="item.name" label="Фамилия Имя" w="6"/>
      <f-input v-model="item.email" label="Email" w="6"/>

      <div v-if="form.edit && this.login" class="col-12">
        <small>Оставьте поля пустыми или введите данные, чтобы поменять пароль. </small>
      </div>

      <f-input v-if="form.edit" v-model="password1" type="password" label="Пароль" w="6"/>
      <f-input v-if="form.edit" v-model="password2" type="password" label="Пароль повторно" w="6"/>

      <f-input v-model="item.admin" type="switch" label="Администратор" w="12"/>
      <f-input v-model="item.active" type="switch" label="Активный" w="12"/>
    </template>

    <template v-if="!noEdit" v-slot:actions="form">
      <button v-if="login && !form.edit" @click.prevent="getToken" class="btn btn-outline-primary">API token</button>
    </template>


  </std-form-page>

</template>

<script>
import FInput from "@/components/FInput";
import StdFormPage from "@/components/StdFormPage";
import {http} from "@/misc/http";
import {uuid4} from "@/misc/util";
import {config} from "@/state/config";

export default {
  components: {StdFormPage, FInput},
  props: ["login"],
  data() {
    return {
      item: {
        login: "",
        password: "",
        name: "",
        email: "",
        admin: false,
        active: true,
      },
      password1: "",
      password2: "",
    }
  },

  methods: {
    beforeSend() {
      if (!this.item.login) throw Error("Должен быть задан логин.");
      if (!this.login && !(this.password1 || this.password2)) throw Error("Должен быть задан пароль для нового пользователя.");
      if ((this.password1 || this.password2) && (this.password1 != this.password2)) throw Error("Пароли не совпадают.");
      this.item.password = this.password1 || null;
      return true;
    },

    async getToken() {
      await this.$refs.page.wrap(async () => {
        return await http.get("/users/" + this.login + "/token");
      });
    },
  },

  computed: {
    noEdit() {
      return !!config.keycloak;
    },
  },


}
</script>

